import { useEffect } from "react";
import { useState } from "react";
import { useCallback } from "react";
import "./App.scss";
//import logo from './logo.svg';
//import Login from './routes/login';
//import Administrator from './routes/administrator';
//import LiveView from './routes/liveview';
//import LiveViewList from './routes/liveviewlist';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";

// import Administrator from "./routes/administrator";
import User from "./routes/user";
import Login from "./routes/login";
import Logout from "./routes/logout";
import Home from "./routes/home";
import HomePage from "./routes/homepage";
import HomePages from "./routes/homepages";
import Map from "./routes/map";
import Maps from "./routes/maps";
import Articles from "./routes/articles";
import ArticlesByTagId from "./routes/articles-by-tag-id";
import ArticlesTags from "./routes/articlestags";
import ArticleTagDetail from "./routes/articletagdetail";
import LiveView from "./routes/liveview";
import LiveViewByTagId from "./routes/liveview-by-tag-id";
import LiveDetail from "./routes/livedetail";
import LiveTags from "./routes/livetags";
import LiveTagDetail from "./routes/livetagdetail";
import Users from "./routes/userpermissions";
import Info from "./routes/info";
import NotFound from "./routes/notfound";
import Sidebar from "./components/sidebar";
import Navbar from "./components/navbar";
import AuthContext from "./context/auth-context";
import { AuthService } from "./services/auth-service";
require("moment/locale/it.js");

export default function App() {
  // const token = localStorage.getItem("proxyAuthToken");
  // const navigate = useNavigate();
  const [_isLogged, _setIsLogged] = useState(false);
  const [permissionList, setPermissionList] = useState([]);

  const _refreshIsLogged = useCallback(() => {
    const token = localStorage.getItem("proxyAuthToken");
    if (token && !_isLogged) {
      _setIsLogged(true);
      return true;
    } else if (!token && _isLogged) {
      _setIsLogged(false);
      return false;
    } else {
      return _isLogged;
    }
  }, [_isLogged]);

  function RequireAuth() {
    const token = localStorage.getItem("proxyAuthToken");
    let location = useLocation();

    if (!token) {
      return <Navigate to="/login" state={{ from: location }} />;
    }
    return <Outlet />;
  }

  const fetchData = useCallback(async () => {
    const prsList = await AuthService.getPermissionList({
      //id: '',
      username: localStorage.username,
      //groups: [],
      //user_permissions__codename: 'can_edit_homes'
    });

    var objectList = prsList.results[0].permissions.map(function (permission) {
      return permission;
    });
    //console.log("PermissionList: ", objectList);
    setPermissionList(objectList);
  }, []);

  useEffect(() => {
    _refreshIsLogged();
    fetchData();
    //   if (!token) {
    //     navigate('/login')
    //   } else {
    //     //navigate('/homepage/')
    //     navigate('/administrator');
    //   }
  }, [_refreshIsLogged, fetchData]);

  return (
    <>
      <BrowserRouter>
        <AuthContext.Provider
          value={{
            isLogged: _isLogged,
            permissionList: permissionList,
            refreshIsLogged: _refreshIsLogged,
          }}
        >
          <div className="d-flex flex-column overflow-y-auto h-100">
            <Navbar />
            <div
              style={{
                display: "flex",
                height: "calc(100% - 40px)",
                width: "100%",
                maxWidth: "100%",
              }}
            >
              <Sidebar />
              <div
                className="shadow p-3"
                style={{ flex: 8, overflowX: "auto" }}
              >
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Login />} />

                  <Route path="/info" element={<Info />} />
                  <Route element={<RequireAuth />}>
                    <Route path="/user" element={<User />} />
                    {/* <Route path="/administrator" element={<Administrator />} /> */}
                    <Route path="/homepages/" element={<HomePages />} />
                    <Route path="/homepage/:uri" element={<HomePage />} />
                    <Route path="/maps/" element={<Maps />} />
                    <Route path="/map/:id" element={<Map />} />
                    <Route path="/articles" element={<Articles />} />
                    <Route path="/articlestags" element={<ArticlesTags />} />
                    <Route
                      path="/articles-by-tag-id/:tagId"
                      element={<ArticlesByTagId />}
                    />
                    <Route
                      path="/articletagdetail/:id"
                      element={<ArticleTagDetail />}
                    />
                    <Route path="/liveview" element={<LiveView />} />
                    <Route
                      path="/liveview-by-tag-id/:tagId"
                      element={<LiveViewByTagId />}
                    />
                    <Route path="/livedetail/:id" element={<LiveDetail />} />
                    <Route path="/livetags" element={<LiveTags />} />
                    <Route path="/userpermissions" element={<Users />} />
                    <Route
                      path="/livetagdetail/:id"
                      element={<LiveTagDetail />}
                    />
                    <Route path="/logout" element={<Logout />} />
                  </Route>
                  <Route path="*" element={<NotFound />} />
                  {/* <Route
              path="*"
              element={
                <main style={{ padding: "1rem" }}>
                  <p>La pagina che cerchi non esiste!</p>
                </main>
              }
            /> */}
                </Routes>
              </div>
            </div>
          </div>
        </AuthContext.Provider>
      </BrowserRouter>
    </>
  );
}
